export default __webpack_public_path__ + "static/media/14.ea9fa9d7.png";